import { consentCategoryId } from '../fixture-ids';

export const consentCategoryLegacyAlternates = {
  // No id at all -- a self-referential name match, the only handle the row has.
  // Declared only here, never on the core entry: the core entry's regression guard asserts
  // entry.parentNameKeys is undefined, and declaring this on core would falsely flag every
  // current-generation row unattributed.
  CONSENT_CATEGORY_UPDATED: {
    parentNameKeys: [{ key: 'consentCategoryName', entity: 'consentCategory' }],
  },
};

export const consentCategoryLegacyFixtures = {
  CONSENT_CATEGORY_CREATED: {
    action: 'CONSENT_CATEGORY_CREATED',
    debugData: { consentCategoryId, consentCategoryName: 'Marketing', consentCategoryCode: 'MARKETING' },
  },
  // No id -- the only handle is the parentNameKeys alternate declared above.
  CONSENT_CATEGORY_UPDATED: {
    action: 'CONSENT_CATEGORY_UPDATED',
    debugData: { consentCategoryName: 'Marketing Communications', consentCategoryCode: 'MARKETING' },
  },
  // No consentCategoryCode in legacy (the builder drops it even though the caller supplies it).
  CONSENT_CATEGORY_DELETED: {
    action: 'CONSENT_CATEGORY_DELETED',
    debugData: { consentCategoryId, consentCategoryName: 'Marketing' },
  },
};
